

























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components/';
import { openUrl } from '@/util';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
import { DataTypesMixin } from '@/mixins';

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 过审情况-创作方
 */
export default class AcgnAuditNorDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口
  // 1：创作方-审批明细 2：管理方-审批明细
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @StatisticNorAction private getRetrialCycleDetail: any;
  @StatisticAction private getRetrialCycleAdminDetail: any;

  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;

  private apiKey: any = {
    1: 'getRetrialCycleDetail',
    2: 'getRetrialCycleAdminDetail'
  };

  // 1：管理方-总览 2：管理方-项目
  private detailRoute: any = {
    1: 'desk-statisticNorApproveComicDetail',
    2: 'desk-statisticApproveComicDetail'
  };

  private tableConfig: any = {
    columns: [
      {
        label: '环节',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '提交审批',
        prop: 'subcnt',
        render: (h: any, { row }: any) => (this as any).renderLink(row, 'subcnt')
      },
      {
        label: '审批通过',
        prop: 'approve'
      },
      {
        label: '审批拒绝',
        prop: 'refuse'
      },
      {
        label: '过审率',
        prop: 'submit_rate'
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据
  private dataType: number = (this as any).type === 2 ? 4 : 0;
  private renderLink(row: any, key: string) {
    const name = row[key];
    const routeName = this.detailRoute[this.routeType];
    if (this.comicId) {
      return (
        <acgn-permission to={{
          name: routeName,
          params: { id: this.comicId, time: row.time_slot, userid: this.userId }
        }}>
          {name}
        </acgn-permission>
      );
    }
    return (
      <span>{name}</span>
    );
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();
    const { result } = await (this as any)[this.apiKey[this.type]](options);
    tableConfig.data = result;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      user_id: this.userId,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private selectChange() {
    this.initSearh();
  }

  private exportExcel() {
    if (this.type === 1) {
      openUrl('/api/v1/workbench/retrialcycle?export=1', this.getSearchOptions());
    } else {
      openUrl('/api/v1/workbench/retrialcycleofadmin?export=1', this.getSearchOptions());
    }
  }
}
